export default __webpack_public_path__ + "static/media/WAG Symbols Bold.45e564c9.otf";